import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronUp = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		stroke: "none",
		strokeWidth: 1,
		fill: "var(--main-color)",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M18 15a1 1 0 01-.64-.23L12 10.29l-5.37 4.32a1 1 0 01-1.41-.15 1 1 0 01.15-1.41l6-4.83a1 1 0 011.27 0l6 5a1 1 0 01.13 1.41A1 1 0 0118 15z",
			fillRule: "nonzero"
		})
	})
});
export { SvgChevronUp as ReactComponent };
